import { connect } from 'react-redux';
import React, { useRef, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import MaterialIcon from 'material-icons-react';

import {
  Link,
  Header,
  HelpText,
  SubHeader,
  Background,
  LoginPanel,
  LoginHeader,
  MarginRight,
  LoginContent,
  LoginContain,
  MarginBotton,
  SearchLightLogo,
  LoginCard as Card,
  LoginButtonContain
} from './Styled';

import Button from 'components/Button';
import TextInput from 'components/TextInput';
import ErrorDisplay from 'components/ErrorDisplay';

import { login, setPassword } from 'actions/session';
import { errorClear, errorSet } from 'actions/error';
import validator from './validation';

import { getQueryString } from 'utils';

const VerifyContainer = ({
  errors,
  loading,
  history,
  lastReset,
  errorMessage,
  dispatchError,
  dispatchErrorClear,
  dispatchSetPassword,
  ...props
}) => {
  const qs = getQueryString(props);
  const lastResetRef = useRef(lastReset);
  const [success, setSuccess] = useState(false);
  const [state, setState] = useState({
    password: '',
    passwordConfirm: ''
  });

  useEffect(
    function clearErrors() {
      dispatchErrorClear();
    },
    [dispatchErrorClear]
  );

  useEffect(
    function onResetSuccess() {
      if (lastResetRef.current !== lastReset) {
        setSuccess(true);
      }

      lastResetRef.current = lastReset;
    },
    [lastReset]
  );

  const handleReset = () => {
    let [isValid, inputErrors] = validator(state);

    if (!isValid) {
      return dispatchError({ inputErrors });
    }

    dispatchSetPassword({ ...state, token: qs.get('token') });
  };

  const onChange = (name, value) => {
    if (errors[name]) {
      dispatchError({ inputErrors: { ...errors, [name]: undefined } });
    }

    setState((s) => ({ ...s, [name]: value }));
  };

  const onLogin = () => history.replace('/login');

  const renderReset = () => (
    <React.Fragment>
      <HelpText>
        <MarginRight>
          <MaterialIcon
            size={'small'}
            icon="info_outline"
            color={'rgb(1, 118, 190)'}
          />
        </MarginRight>
        <span>Please enter and confirm your new account password below.</span>
      </HelpText>

      <TextInput
        bold
        fullWidth
        name={'password'}
        type="password"
        disabled={loading}
        value={state.password}
        errorText={errors.password}
        label={'Password'}
        onChange={onChange}
        placeholder={'Enter your new password'}
      />

      <TextInput
        bold
        fullWidth
        type="password"
        disabled={loading}
        name={'passwordConfirm'}
        value={state.passwordConfirm}
        errorText={errors.passwordConfirm}
        label={'Password Confirm'}
        onChange={onChange}
        placeholder={'Confirm your new password'}
      />

      <LoginButtonContain>
        <Button.Primary
          label={'Set Password'}
          icon={!loading && 'lock_outline'}
          loading={loading}
          disabled={loading}
          onClick={handleReset}
        />
      </LoginButtonContain>

      <MarginBotton />
    </React.Fragment>
  );

  const renderSuccess = () => (
    <React.Fragment>
      <SubHeader>Reset Success!</SubHeader>
      <HelpText>
        <MarginRight>
          <MaterialIcon
            size={'small'}
            icon="mail_outline"
            color={'rgb(1, 118, 190)'}
          />
        </MarginRight>
        <span>Your password has been successfully reset.</span>
      </HelpText>
    </React.Fragment>
  );

  return (
    <Background>
      <LoginContain>
        <LoginPanel>
          <Card>
            <LoginHeader>
              <SearchLightLogo />
              <Header>Set New Password</Header>
            </LoginHeader>

            <LoginContent>
              {success ? renderSuccess() : renderReset()}

              {!loading && <ErrorDisplay message={errorMessage} />}

              <Link href="#" onClick={onLogin}>
                Login
              </Link>
            </LoginContent>
          </Card>
        </LoginPanel>
      </LoginContain>
    </Background>
  );
};

const mapDispatchToProps = {
  dispatchLogin: login,
  dispatchError: errorSet,
  dispatchErrorClear: errorClear,
  dispatchSetPassword: setPassword
};

const mapStateToProps = ({ error, session, loading }) => ({
  isAuth: session.isAuth,
  errors: error.inputErrors || {},
  errorMessage: error.message,
  loading: loading.loadingResetPassword,
  lastReset: session.lastPasswordReset
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(VerifyContainer)
);
